var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-empty"},[_c('img',{attrs:{"src":require("@/static/images/plan/empty-jzx.png"),"alt":""}}),_c('div',{staticClass:"empty-text",domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._t("index-empty-tip")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }